<template>
  <form novalidate class="md-layout" :class="content.class_color" @submit.prevent="validateContact">

    <md-field :class="getValidationClass2('fullname')" class="form-mb-5">
      <label for="fullname">Nombres</label>
      <md-input name="fullname" id="fullname" class="input-black" autocomplete="off" v-model="form2.fullname"
        :disabled="sending" />
      <span class="md-error" v-if="!$v.form2.fullname.required">Los nombres son requerida</span>
      <span class="md-error" v-else-if="!$v.form2.fullname.minlength">Caracteres mínimos: 1</span>
      <span class="md-error" v-else-if="!$v.form2.fullname.maxLength">Caracteres máximos: 100</span>

    </md-field>

    <md-field style="min-height: 0px; margin: 0px">
      <label for="address">
        Tipo de documento
      </label>
    </md-field>

    <md-field :class="getValidationClass2('documentTypeId')" class="form-mb-5">
      <b-form-select v-model="form2.documentTypeId" :options="typesdocument.abbreviation" id="documentTypeId"
        v-on:change="onChangeCategoryDocument($event)">
        <b-form-select-option v-for="item in typesdocument" :key="item.documentTypeId" :value="item.documentTypeId">{{
          item.abbreviation }}</b-form-select-option>
      </b-form-select>
      <span class="md-error" v-if="!$v.form2.documentTypeId.required">El tipo de documento es requerido</span>

    </md-field>

    <md-field :class="getValidationClass2('document_number')" class="form-mb-5">
      <label for="document_number">N° de documento</label>
      <md-input name="document_number" id="document_number" class="input-black" autocomplete="off"
        v-model="form2.document_number" :disabled="sending" />
      <span class="md-error" v-if="!$v.form2.document_number.required">El N° de documento es requerida</span>
      <span class="md-error" v-else-if="!$v.form2.document_number.minlength">Caracteres mínimos: 8</span>
      <span class="md-error" v-else-if="!$v.form2.document_number.maxLength">Caracteres máximos: 8</span>
    </md-field>

    <md-field :class="getValidationClass2('address')" class="form-mb-5">
      <label for="address">Dirección</label>
      <md-input name="address" id="address" class="input-black" autocomplete="off" v-model="form2.address"
        :disabled="sending" />
      <span class="md-error" v-if="!$v.form2.address.required">La dirección es requerida</span>
      <span class="md-error" v-else-if="!$v.form2.address.minlength">Caracteres mínimos: 1</span>
      <span class="md-error" v-else-if="!$v.form2.address.maxLength">Caracteres máximos: 100</span>
    </md-field>

    <md-field style="min-height: 0px; margin: 0px">
      <label for="address">
        Departamento
      </label>
    </md-field>

    <md-field class="form-mb-5" v-if="departamentos.length > 0">

      <b-form-select :options="departamentos.departament" id="department" place v-on:change="onChangeDepartment($event)">
        <b-form-select-option v-for="item in departamentos" :key="item.departamentId" :value="item.departamentId">{{
          item.departament }}</b-form-select-option>
      </b-form-select>

    </md-field>

    <md-field style="min-height: 0px; margin: 0px">
      <label for="address">
        Provincia
      </label>
    </md-field>

    <md-field class="form-mb-5">
      <b-form-select :options="provinces.province" id="province" v-on:change="onChangeProvince($event)">
        <b-form-select-option v-for="item in provinces" :key="item.provinceId" :value="item.provinceId">{{ item.province
        }}</b-form-select-option>
      </b-form-select>
    </md-field>

    <md-field style="min-height: 0px; margin: 0px">
      <label for="address">
        Distrito
      </label>
    </md-field>

    <md-field :class="getValidationClass2('districtId')" class="form-mb-5">
      <b-form-select v-model="form2.districtId" :options="districts.district" id="districtId"
        v-on:change="onChangeDistrict($event)">
        <b-form-select-option v-for="item in districts" :key="item.districtId" :value="item.districtId">{{ item.district
        }}</b-form-select-option>
      </b-form-select>
      <span class="md-error" v-if="!$v.form2.districtId.required">El distrito es requerido</span>
    </md-field>

    <md-field :class="getValidationClass2('prefix_phone')" class="form-mb-5">
      <label for="prefix_phone">Codigo de Area</label>
      <b-form-select :options="provinces.province" id="province" v-on:change="onChangeProvince($event)">
        <b-form-select-option v-for="item in provinces" :key="item.provinceId" :value="item.provinceId">{{ item.province
        }}</b-form-select-option>
      </b-form-select>
      <span class="md-error" v-if="!$v.form2.prefix_phone.required">El Codigo de Area es requerido</span>
    </md-field>

    <md-field :class="getValidationClass2('mobilephone')" class="form-mb-5">
      <label for="mobilephone">Celular/Teléfono</label>
      <md-input name="mobilephone" id="mobilephone" class="input-black" autocomplete="off" v-model="form2.mobilephone"
        :disabled="sending" />
      <span class="md-error" v-if="!$v.form2.mobilephone.required">El celular/teléfono es requerida</span>
      <span class="md-error" v-else-if="!$v.form2.mobilephone.minlength">Caracteres mínimos: 9</span>
      <span class="md-error" v-else-if="!$v.form2.mobilephone.maxLength">Caracteres máximos: 9</span>
    </md-field>

    <md-field :class="getValidationClass2('email')" class="form-mb-5">
      <label for="email">Email</label>
      <md-input name="email" id="email" class="input-black" autocomplete="off" v-model="form2.email"
        :disabled="sending" />
      <span class="md-error" v-if="!$v.form2.email.required">El email es requerido</span>
      <span class="md-error" v-else-if="!$v.form2.email.email">Email inválido</span>
    </md-field>

    <md-field :class="getValidationClass2('claim_about')" class="form-mb-5">
      <b-form-select v-model="form2.claim_about" :options="tiporeclamo" id="claim_about"
        v-on:change="onChangeTypeClaim($event)">
        <b-form-select-option v-for="(item, index) in content" :key="index" :value="item.value">{{ item.text
        }}</b-form-select-option>
      </b-form-select>
      <span class="md-error" v-if="!$v.form2.claim_about.required">Tipo de reclamo es requerido</span>
    </md-field>

    <md-field :class="getValidationClass2('claim_detail')" class="form-mb-5">
      <label for="claim_detail">Detalles de reclamo.</label>
      <md-textarea name="claim_detail" id="claim_detail" class="input-black" autocomplete="off"
        v-model="form2.claim_detail" :disabled="sending"></md-textarea>
      <span class="md-error" v-if="!$v.form2.claim_detail.required">El detalle de reclamo es requerido</span>
      <span class="md-error" v-else-if="!$v.form2.claim_detail.minlength">Caracteres mínimos: 3</span>
      <span class="md-error" v-else-if="!$v.form2.claim_detail.maxLength">Caracteres máximos: 400</span>
    </md-field>

    <md-field :class="getValidationClass2('claim_actions')" class="form-mb-5">
      <label for="claim_actions">Acciones tomadas por la empresa.</label>
      <md-textarea name="claim_actions" id="claim_actions" class="input-black" autocomplete="off"
        v-model="form2.claim_actions" :disabled="sending"></md-textarea>
      <span class="md-error" v-if="!$v.form2.claim_actions.required">Las acciones tomadas son requeridas</span>
      <span class="md-error" v-else-if="!$v.form2.claim_actions.minlength">Caracteres mínimos: 3</span>
      <span class="md-error" v-else-if="!$v.form2.claim_actions.maxLength">Caracteres máximos: 400</span>
    </md-field>

    <div class="md-field formulario-center-button">
      <div id="formulario-boton">
        <button v-if="content.boton_img" type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global">
            {{ content.text_boton }}
            <!-- <img src="@/assets/images/arrow_left.svg"> -->
          </span>
        </button>
        <button v-else type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global-normal"> {{ content.text_boton }}</span>
        </button>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlert">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send" class="alert-sended" v-model="showDismissibleAlert"
          dismissible>
          <span> <strong>{{ lastUser }}</strong><br> Su reclamo fue recibido.</span>
        </b-alert>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlertError">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send-ganger" variant="danger" v-model="showDismissibleAlertError"
          dismissible>
          <span> Intente mas tarde</span>
        </b-alert>
      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="sending" :can-cancel="true" loader="dots" color="#FFC100" backgroundColor="black" :width=128
        :height=128 :is-full-page="true">
      </loading>
    </div>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { getDepartments, getDocumentsType } from '@/api'
// import axios from 'axios'
import {
  required,
  email,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators'
//  import CountryFlag from 'vue-country-flag'
export default {
  name: 'formularioClaim',
  mixins: [validationMixin],
  components: { Loading },
  props: { content: Object },

  data: () => ({

    departamentos: [],
    provinces: [],
    districts: [],
    typesdocument: [],
    province: null,
    department: null,




    /*form: {
      category_name: null,
      countryId: null,
      email: null,
      ruc: null,
      business_name: null,
      fullname: null,
      mobilephone: null,
      prefix_phone: null
    },*/
    form2: {
      fullname: null,
      documentTypeId: null,
      document_number: null,
      address: null,
      //department: null,
      //province: null,
      districtId: null,
      mobilephone: null,
      email: null,
      claim_about: null,
      claim_detail: null,
      claim_actions: null
    },
    selected: null,
    selected2: '+51',
    dataselected: [
      { value: null, text: 'Departamento' }
    ],
    options: [
      { value: null, text: 'Rubro' },
      { value: 'Comidas', text: 'Comidas' },
      { value: 'Market', text: 'Market' },
      { value: 'Salud', text: 'Salud' },
      { value: 'Tiendas', text: 'Tiendas' },
      { value: 'Spa y Belleza', text: 'Spa y Belleza' },
      { value: 'Deporte', text: 'Deporte' },
      { value: 'Hot & Fun', text: 'Hot & Fun' },
      { value: 'Arte y entretenimiento', text: 'Arte y entretenimiento' },
      { value: 'Mascotas', text: 'Mascotas' },
      { value: 'Servicios', text: 'Servicios' }
    ],
    options2: [
      {
        value: { countryId: 176, country_code: "pe", country_name: "Peru", phone_code: "51" },
        text: '+51'
      },
      {
        value: { countryId: 11, country_code: "ar", country_name: "Argentina", phone_code: "54" },
        text: '+54'
      },
      {
        value: { countryId: 47, country_code: "co", country_name: "Colombia", phone_code: "57" },
        text: '+57'
      },
      {
        value: { countryId: 45, country_code: "cl", country_name: "Chile", phone_code: "56" },
        text: '+56'
      }
    ],
    options3: [
      { value: null, text: 'Tipo de documento' },
      { value: '1', text: 'Dni' },
      { value: '2', text: 'Pasaporte' },
      { value: '3', text: 'Carnet de extranjería' }
    ],
    options4: [
      { value: null, text: 'Departamento' },
      { value: 1, text: 'Lima' },
      { value: 2, text: 'Ica' },
      { value: 3, text: 'Trujillo' },
      { value: 4, text: 'Callao' },
      { value: 5, text: 'Arequipa' },
      { value: 6, text: 'Loreto' },
      { value: 7, text: 'Madre de Dios' },
      { value: 8, text: 'Chiclayo' },
      { value: 9, text: 'Cuzco' }
    ],

    options5: [
      { value: null, text: 'Provincia' },
      { value: 1, text: 'Barranca' },
      { value: 2, text: 'Cajatambo' },
      { value: 3, text: 'Canta' },
      { value: 4, text: 'Cañete' },
      { value: 5, text: 'Huaral' },
      { value: 6, text: 'Huarochirí' },
      { value: 7, text: 'Huaura' },
      { value: 8, text: 'Lima' },
      { value: 9, text: 'Yauyos' }
    ],

    options6: [
      { value: null, text: 'Distrito' },
      { value: 1, text: 'Miraflores' },
      { value: 2, text: 'San Borja' },
      { value: 3, text: 'San Juan de Lurigancho' },
      { value: 4, text: 'Comas' },
      { value: 5, text: 'Carabayllo' },
      { value: 6, text: 'Los Olivos' },
      { value: 7, text: 'Cercado de Lima' },
      { value: 8, text: 'Surquillo' },
      { value: 9, text: 'Magdalena' }
    ],
    tiporeclamo: [
      { value: null, text: 'Tipo de reclamo' },
      { value: 1, text: 'Producto' },
      { value: 2, text: 'Servicio' },
    ],

    contactSaved: false,
    sending: false,
    lastUser: null,
    showDismissibleAlert: false,
    showDismissibleAlertError: false
  }),
  mounted() {

    getDepartments()
      .then((response) => response)
      .then((datax) => {
        this.departamentos = datax.data
      })

    getDocumentsType()
      .then((response) => response)
      .then((datax) => {
        this.typesdocument = datax.data
      })



    /*this.$store.dispatch('getDepartments')
        .then((response) => {
          
          const promise =  response.data.map(
                     data => {
                                 
                     }
                 )
          return promise
          console.log(JSON.parse(JSON.stringify(response.data)))
          this.departamentos = (JSON.parse(JSON.stringify(response.data)))
          console.log(this.departamentos)
          //this.departaments = response.data   
          //console.log('encontré los depas', this.departaments)
        })
        .catch((error) => {
          console.log('error registerContact', error)
        })*/





    // this.sending = true
    // this.success = false
    //   axios.get('/ubigeo/countries')
    //         .then(
    //           result => {

    //             const promise =  result.data.map(
    //                 data => {
    //                   console.log(data, 'hey dataaaaa')
    //                   return {
    //                     value: { code: '+' + data.phone_code, countryId: data.countryId   }, text: '+' + data.phone_code }
    //                 }
    //             )
    //             return promise

    //             // this.prefixCodes = result
    //             // console.log(result.data, 'countriesssss')
    //           }
    //         )

    //  .then(
    //                 result => {
    //                   console.log(JSON.parse(JSON.stringify(result)) )
    //                   this.options2 = JSON.parse(JSON.stringify(result)) 
    //                 }
    //           )
    //         .catch( err => err)



  },
  validations: {
    /*form: {
      countryId: {
        required
      },
      fullname: {
        required,
        minLength: minLength(3)
      },
      business_name: {
        required,
        minLength: minLength(3)
      },
      ruc: {
        required,
        minLength: minLength(11),
        maxLength: maxLength(11)
      },
      category_name: {
        required
      },
      prefix_phone: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(5)
      },
      mobilephone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(11)
      },
      email: {
        required,
        email
      }
    },*/
    form2: {
      fullname: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(100)
      },
      documentTypeId: { required },
      document_number: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },
      address: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(100)
      },
      //department: {required},
      //province: {required},
      districtId: { required },
      mobilephone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      email: {
        required,
        email
      },
      claim_about: { required },
      claim_detail: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(400)
      },
      claim_actions: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(400)
      }
    }
  },
  methods: {
    /*getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
 
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },*/
    getValidationClass2(fieldName) {
      const field = this.$v.form2[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm() {
      this.$v.$reset()

      /*this.form.category_name = null
      this.form.countryId = null
      this.form.email = null
      this.form.ruc = null
      this.form.business_name = null
      this.form.fullname = null
      this.form.mobilephone = null
      this.form.prefix_phone = null*/

      this.form2.fullname = null
      this.form2.documentTypeId = null
      this.form2.document_number = null
      this.form2.address = null
      //this.form2.department = null
      //this.form2.province = null
      this.form2.districtId = null
      this.form2.mobilephone = null
      this.form2.email = null
      this.form2.claim_about = null
      this.form2.claim_detail = null
      this.form2.claim_actions = null


    },
    onChangePrefix: function (e) {
      if (e) {
        this.result = JSON.parse(JSON.stringify(e))
        //this.form.prefix_phone = this.result.phone_code
        //this.form.countryId = this.result.countryId
      }

    },
    onChangeCategoryDocument: function (e) {
      this.form2.documentTypeId = e

    },
    onChangeDepartment: function (e) {
      this.department = e
      this.$store.dispatch('getProvinces', this.department)
        .then((response) => {
          this.provinces = response.data
        })
        .catch((error) => error)





    },
    onChangeProvince: function (e) {
      this.province = e
      this.$store.dispatch('getDistrict', this.province)
        .then((response) => {
          this.districts = response.data
        })
        .catch((error) => error)

    },
    onChangeDistrict: function (e) {
      this.form2.districtId = e

    },
    onChangeTypeClaim: function (e) {
      this.form2.claim_about = e

    },
    saveContact() {
      this.sending = true
      //this.form.countryId = 176
      //this.form.mobilephone =   this.form.mobilephone.replace(/ /g, "")
      //this.form.prefix_phone = '+51'
      // console.log(
      //   this.form.business_name,
      //   this.form.category_name,
      //   this.form.countryId,
      //   this.form.email,
      //   this.form.fullname,
      //   this.form.mobilephone,
      //   this.form.prefix_phone
      //   , 'hey formularioo')
      this.$store.dispatch('postClaim', this.form2)
        .then(() => {
          this.showDismissibleAlert = true
          // this.lastUser = `${this.form.name} ${this.form.phone}`
          this.contactSaved = true
          this.sending = false
          this.clearForm()
          //            alert('Pronto sera atendido por uno de nuestros equipos GOX')
          /*revisar esto es para la barra de carga*/
          //            window.setTimeout(() => {
          //              this.lastUser = `${this.form.name} ${this.form.phone}`
          //              this.contactSaved = true
          //              this.sending = false
          //              this.clearForm()
          //            }, 1500)
        })
        .catch(() => {
          this.sending = false
          this.showDismissibleAlertError = true
        })
      // Instead of this timeout, here you can call your API

    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    validateContact() {
      this.$v.$touch()
      // console.log('validate contact touchhh',
      //   //this.form.business_name,
      //   //this.form.category_name,
      //   //this.form.countryId,
      //   //this.form.email,
      //   //this.form.fullname,
      //   //this.form.mobilephone,
      //   //this.form.prefix_phone,
      //   //this.form.ruc
      // )
      if (!this.$v.$invalid) {
        this.saveContact()
      }
    },
    getPrefixTlf() {

    },
    srcImagen(img) {
      let src = require('@/assets/images/' + img)
      return src
    },
    doAjax() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    },
    onCancel() {
      // console.log('User cancelled the loader.')
    }
  }
}
</script>
<style scoped>
#alert-send.alert-info {
  background-color: green !important;
}

.alert-sended {
  background-color: green !important;
  border: green !important;
}
</style>